module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daycloud-4ec2fe8fbd37be687dacb002f3de37ff.webp";